export default __webpack_public_path__ + "static/media/lock.af482d86.svg";